import { render, staticRenderFns } from "./moreInfo.vue?vue&type=template&id=513f7aab&scoped=true"
import script from "./moreInfo.vue?vue&type=script&lang=js"
export * from "./moreInfo.vue?vue&type=script&lang=js"
import style0 from "./moreInfo.vue?vue&type=style&index=0&id=513f7aab&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f7aab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513f7aab')) {
      api.createRecord('513f7aab', component.options)
    } else {
      api.reload('513f7aab', component.options)
    }
    module.hot.accept("./moreInfo.vue?vue&type=template&id=513f7aab&scoped=true", function () {
      api.rerender('513f7aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/dialog/moreInfo.vue"
export default component.exports